import { AxiosRequestConfig } from 'axios';

const config: AxiosRequestConfig = {
  headers: {
    'content-type': 'application/json',
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AUTH_API_KEY as string,
  },
};
export default config;
